import moment from "moment";
import React from "react";
import { getSupplierName } from "../../../../data/flight/supplier/getSupplierName";

function ChangeDateConfirmationOrderIdContainer({ data }) {
  const booking = data?.changedFlightBooking;
  const ogBooking = Array.isArray(data?.flightBooking)
    ? data.flightBooking[0]
    : data?.flightBooking;
  const airlinePnr = [
    ...new Set(
      (ogBooking?.travelers || [])
        .flatMap((traveler) => traveler?.pnrList || [])
        .map((pnr) => (pnr?.airlinePnr || "").toLocaleUpperCase())
        .filter(Boolean),
    ),
  ].join(" | ");
  const tickets = [
    ...new Set(
      (ogBooking?.travelers || [])
        .flatMap((traveler) => traveler?.ticketNumbers || [])
        .filter(Boolean),
    ),
  ];
  const airline =
    ogBooking?.flights?.[0]?.airlineName ||
    ogBooking?.flights?.[0]?.airline ||
    ogBooking?.validatingAirline ||
    "-";
  const supplier =
    getSupplierName(ogBooking?.supplier || data?.supplier) ||
    ogBooking?.supplier ||
    data?.supplier ||
    "-";

  return (
    <div className="w-full rounded-md border border-primary1/10 bg-primary1/5 mt-4">
      <div className="h-1 w-full bg-primary1" />

      <div className="p-3 sm:p-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-4 items-start">
          <div>
            <div className="text-xs text-gray-500">Order date</div>
            <div className="mt-1 text-sm text-gray-800">
              {moment(data?.createdAt).format("MM/DD/YYYY  hh:mmA [GMT]Z")}
            </div>
          </div>

          <div>
            <div className="text-xs text-gray-500">Original Order Id</div>
            <a
              target="_blank"
              rel="noreferrer"
              href={`/order/flight/ticket/detail/${ogBooking?.bookingId}?page=Bookings`}
              className="mt-1 text-sm text-primary1 cursor-pointer hover:underline"
            >
              {ogBooking?.bookingId || "-"}
            </a>
          </div>

          <div>
            <div className="text-xs text-gray-500">Date Change ID</div>
            <div className="mt-1 text-sm text-gray-800">
              {data?.orderId || booking?.bookingId || "-"}
            </div>
          </div>

          <div>
            <div className="text-xs text-gray-500">Ticket</div>
            <div className="mt-1 text-sm text-gray-800">
              {tickets.length ? tickets.join(" | ") : "-"}
            </div>
          </div>

          <div>
            <div className="text-xs text-gray-500">Airline</div>
            <div className="mt-1 text-sm text-gray-800">{airline}</div>
          </div>

          <div>
            <div className="text-xs text-gray-500">Supplier</div>
            <div className="mt-1 text-sm text-gray-800">{supplier}</div>
          </div>

          <div>
            <div className="text-xs text-gray-500">GDS PNR</div>
            <div className="mt-1 text-sm text-gray-800">
              {ogBooking?.pnr || booking?.pnr || "-"}
            </div>
          </div>

          <div>
            <div className="text-xs text-gray-500">Airline PNR</div>
            <div className="mt-1 text-sm text-gray-800">{airlinePnr || "-"}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChangeDateConfirmationOrderIdContainer;
